import { ICellRendererParams } from '@ag-grid-community/core';

import './BtnTrashRenderer.css';
const BtnTrashRenderer = (props: ICellRendererParams) => {
  return (
    <img src="images/trash-can.svg" alt="Trash Button" className="grid_trash_btn" />
  );
};

export default BtnTrashRenderer;
